import { DocumentInclusion } from '../config/types';

export const normalizeInclusionValue = (
  inclusion?: string,
): DocumentInclusion =>
  inclusion?.toLowerCase() === 'always' ? 'always' : 'on_demand';
